import { SampleSet } from "@/services/backend/sample-set/sample-set";
import { Card, CardContent } from "@/shared/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import { formatDate } from "@/shared/utilities/date";
import { ReactNode } from "react";

interface ProcedureMetadataProps {
  samplesets: SampleSet[];
}

export default function SampleSetMetadataRow({
  samplesets,
}: ProcedureMetadataProps): ReactNode {
  return (
    <Card className="p-0">
      <CardContent className="p-0">
        <Table>
          <SampleSetMetadataTableHeader />
          <SampleSetMetadataTableBody samplesets={samplesets} />
        </Table>
      </CardContent>
    </Card>
  );
}

function SampleSetMetadataTableHeader() {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>Messgerät</TableHead>
        <TableHead>Lochanzahl</TableHead>
        <TableHead>Probennehmer</TableHead>
        <TableHead>Beginn der Probenahme</TableHead>
      </TableRow>
    </TableHeader>
  );
}

function SampleSetMetadataTableBody({
  samplesets,
}: {
  samplesets: SampleSet[];
}) {
  if (samplesets.length === 0) {
    <TableBody>Kein Luftkeimmesser vorhanden</TableBody>;
  }

  return (
    <TableBody>
      <TableRow key={samplesets[0].id}>
        <TableCell>{samplesets[0].airSampler?.description}</TableCell>
        <TableCell>{samplesets[0].airSampler?.holeCount}</TableCell>
        <TableCell>{samplesets[0].sampleTakers}</TableCell>
        <TableCell>{formatDate(samplesets[0].sampleDate)}</TableCell>
      </TableRow>
    </TableBody>
  );
}
